import React from "react";
import { render } from "react-dom";
import "./assets/style.css";
import App from "./App";
import Store from "./Store";
import * as serviceWorker from "./serviceWorker";

const Index = () => {
  return (
    // Store contains context providers which is then rendering App inside
    <Store>
      <App />
    </Store>
  );
};

render(<Index />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
